import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import "./Home.css";

export default function Home({ config }) {
  const { client_name, userNickname, userEmail, credits } = config;

  return (
    <div className="app-shell">
      <Sidebar workspaceName={client_name} />
      <div className="app-shell__main">
        <Topbar credits={credits} displayName={userNickname} email={userEmail} />
        <main className="app-shell__content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}